// "3 min ago" for the bots screens. Shared by Overview, Pool and Phrases,
// so it sits beside them rather than inside one of the tabs.

export function formatMinutes(m: number): string {
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} h`;
  return `${Math.floor(h / 24)} d`;
}

export function ago(iso: string | null): string {
  if (!iso) return "—";
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return "—";
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (s < 60) return `${s} s ago`;
  return `${formatMinutes(Math.floor(s / 60))} ago`;
}
